import { Component, OnInit } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import { BaseModal, ListItem } from '../../shared'
import { JobOwnershipsComponent } from './job-ownerships.component'

@Component({
    templateUrl: './add-job-ownership-template.component.html',
    standalone: true,
    imports: [FormsModule, WjInputModule, FaIconComponent],
})
export class AddJobOwnershipTemplateComponent extends BaseModal implements OnInit {
    faSpinner = faSpinner
    selectedJob: any
    templatesMap: ListItem<string>[] = []
    selectedTemplate!: string
    parentComponent!: JobOwnershipsComponent

    readonly title = 'Add Items to Job from Template'

    ngOnInit() {
        // Get a list of jobs that already have ownerships (existing jobs)
        this.templatesMap = this.services.data.jobOwnershipTemplates.items.map(x => new ListItem(x.id, x.name))
        this.selectedTemplate = this.templatesMap[0]?.value
    }

    protected onSave(resolveSave: (result?: any) => void, rejectSave: (reason?: any) => void) {
        const observable = this.services.data.put('api/JobOwnership/AddJobOwnershipsFromTemplate', {
            jobId: this.selectedJob,
            templateId: this.selectedTemplate,
        })
        observable.subscribe({
            next: () => {
                resolveSave(this.selectedJob)
            },
            error: errorResult => {
                rejectSave(errorResult)
            },
        })
    }
}
